// extracted by mini-css-extract-plugin
var _1 = "AppointmentFormModalHintedControl-modulehint___HzRk";
var _2 = "AppointmentFormModalHintedControl-modulehintedControl__TAXm9";
export { _1 as "hint", _2 as "hintedControl" }
